import { merge } from 'lodash';
import firebase from 'firebase';

const authenticationUtils = {
    getUser: () => {
        return firebase.auth().currentUser;
    },

    getUserToken: () => {
        const user = authenticationUtils.getUser();
        if (user !== null) {
            return user.getIdToken(true);
        }
    },
    getUserName: () => {
        const user = authenticationUtils.getUser();
        if (user !== null) {
            return user.displayName;
        }
    },
    getUserEmail: () => {
        const user = authenticationUtils.getUser();
        if (user !== null) {
            return user.email;
        }
    }
};
const pageUtils = {
    getParentFormPath: pathString => {
        let pathArr = pathString.split('/');
        pathArr.pop();
        return pathArr.join('/');
    },

    getRootFormPath: (pathString, removeSlash = false) => {
        let pathChunks = pathString.split('/').filter(part => part !== '');
        let rootPage = pathChunks.shift();

        return removeSlash ? rootPage : '/' + rootPage;
    },

    getObjectStructureFromPath: (pathString, removeRoot = true) => {
        let pathChunks = pathString.split('/');
        pathChunks = pathChunks.filter(part => part !== '');

        const root = pathChunks.shift(); //Remove the root page

        let pagePathStructure = '';
        for (let i = 0; i < pathChunks.length; i++) {
            pagePathStructure += 'subpages.' + pathChunks[i] + (i < pathChunks.length - 1 ? '.' : '');
        }

        return removeRoot ? pagePathStructure : root + '.' + pagePathStructure;
    },
    getSiblingsObjectStructureFromPath: (pathString, removeRoot = true) => {
        let objectStruct = pageUtils.getObjectStructureFromPath(pathString, removeRoot).split('.');
        objectStruct.pop();

        return objectStruct.join('.');
    },

    objectifyPages: pagesArr => {
        let rootPages = {};
        pagesArr.forEach(rootPage => {
            merge(rootPages, { [rootPage.id]: rootPage });
        });
        return rootPages;
    },

    getRouteKey: title => {
        title = title
            .toLowerCase()
            .replace(/[^a-z0-9 ]/g, '')
            .trim(); // only allow alphabet and numeric chars
        title = title.replace(/\s+/g, '-'); // remove spaces and replace with dash

        return title;
    },

    updateParentPath: (page, newParentPath) => {
        page.path = newParentPath + '/' + pageUtils.getRouteKey(page.title);

        for (let subPageKey in page.subpages) {
            page.subpages[subPageKey] = pageUtils.updateParentPath(page.subpages[subPageKey], page.path);
        }

        return page;
    },

    isRootPagePath: pathString => {
        const pathChunks = pathString.split('/').filter(part => part !== '');
        return pathChunks.length === 1;
    }
};

const logUtils = {
    AUTHOR_ACTIONS: {
        CREATE_PAGE: '1',
        DELETE_PAGE: '2',
        UPDATE_NAV_EXCLUDED: '3',
        INDEX_UPDATED: '4',
        INDEX_PUBLISHED: '5',
        PAGE_CONTENT_UPDATED: '6',
        UPDATE_PAGE_SETTINGS: '7',
        PAGE_PUBLISHED: '8',
        NAV_EXCLUDED_PUBLISHED: '9',
        DELETE_PAGE_ON_PUBLISH: '10'
    },

    logAuthorAction: (action, payload) => {
        const { firestoreRef } = require('../utils/firebase');
        const logCollection = firestoreRef.collection('log').doc('author');

        let logObject = {
            utcTimeStamp: new Date().toUTCString(),
            user: authenticationUtils.getUserEmail()
        };

        switch (action) {
            case logUtils.AUTHOR_ACTIONS.CREATE_PAGE:
                logObject.message = `New page '${payload.title}' created with path: '${payload.path}'.`;
                break;
            case logUtils.AUTHOR_ACTIONS.DELETE_PAGE:
                logObject.message = `Page '${payload.title}' deleted, path was: '${payload.path}'.`;
                break;
            case logUtils.AUTHOR_ACTIONS.UPDATE_NAV_EXCLUDED:
                logObject.message = `Excluded pages updated. Paths: '${payload.paths.join(', ')}' are now exluded from the navigation menu.`;
                break;
            case logUtils.AUTHOR_ACTIONS.INDEX_UPDATED:
                logObject.message = `Index page updated. New index page path: '${payload.index}'.`;
                break;
            case logUtils.AUTHOR_ACTIONS.INDEX_PUBLISHED:
                logObject.message = `Index page published. New published index page path: '${payload.index}'.`;
                break;
            case logUtils.AUTHOR_ACTIONS.PAGE_CONTENT_UPDATED:
                logObject.message = `Content update for page with path '${payload.path}'.`;
                break;
            case logUtils.AUTHOR_ACTIONS.UPDATE_PAGE_SETTINGS:
                logObject.message = `Settings of page '${payload.old.title}' on path '${payload.old.path}' updated. New settings: ${JSON.stringify(payload.new)}.`;
                break;
            case logUtils.AUTHOR_ACTIONS.PAGE_PUBLISHED:
                logObject.message = `Page '${payload.title}' with path '${payload.path}' published.`;
                break;
            case logUtils.AUTHOR_ACTIONS.NAV_EXCLUDED_PUBLISHED:
                logObject.message = `Excluded pages published. Paths: '${payload.paths.join(', ')}' are now exluded from the navigation menu.`;
                break;
            case logUtils.AUTHOR_ACTIONS.DELETE_PAGE_ON_PUBLISH:
                logObject.message = `Deleted page with path : '${payload}' on the publish environment.`;
                break;
            default:
                // No message
                break;
        }

        logCollection.update({ actions: firebase.firestore.FieldValue.arrayUnion(logObject) });
    }
};

export { authenticationUtils, pageUtils, logUtils };
